/**
 * CPO 리스트 조회 - res
 */
import { CpoListItem } from "@/model/CpoListItem.ts";

export class ReadCpoListResDto {
    content: CpoListItem[];
}
